import React, { useId, useState } from 'react';

const TEXT = {
    show: 'הצג סיסמה',
    hide: 'הסתר סיסמה',
};

function EyeIcon({ visible }) {
    if (visible) {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M3 3l18 18M10.6 10.6a2 2 0 102.8 2.8M9.9 5.1A10.9 10.9 0 0112 5c5.2 0 9.3 3.3 10.8 7-0.6 1.4-1.6 2.9-3 4.1M6.2 6.3C4.3 7.5 2.9 9.2 2 12c0.8 1.9 2.2 3.8 4.2 5.1A10.7 10.7 0 0012 19c1.6 0 3.2-.3 4.7-1"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
        </svg>
    );
}

export default function PasswordField({
    label,
    value,
    onChange,
    required = false,
    minLength,
    autoComplete,
    placeholder,
    disabled = false,
    name,
}) {
    const generatedId = useId();
    const [isVisible, setIsVisible] = useState(false);
    const inputId = name || generatedId;

    return (
        <label className="form-field" htmlFor={inputId}>
            <span className="form-field__label">{label}</span>
            <div className="password-field">
                <input
                    id={inputId}
                    className="form-field__control password-field__control"
                    type={isVisible ? 'text' : 'password'}
                    value={value}
                    onChange={onChange}
                    required={required}
                    minLength={minLength}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    disabled={disabled}
                    dir="ltr"
                />
                <button
                    type="button"
                    className="password-field__toggle"
                    onClick={() => setIsVisible((prev) => !prev)}
                    aria-label={isVisible ? TEXT.hide : TEXT.show}
                    title={isVisible ? TEXT.hide : TEXT.show}
                    disabled={disabled}
                >
                    <EyeIcon visible={isVisible} />
                </button>
            </div>
        </label>
    );
}
